import styled from "styled-components";
import MuiAccordion, { AccordionProps } from "@mui/material/Accordion";
import { AccordionDetails, Typography } from "@mui/material";

export const CustomAccordion = styled((props: AccordionProps) => (
	<MuiAccordion disableGutters elevation={0} square {...props} />
))(() => ({
	border: "0.5px solid #EBEBEB",
	// "&:not(:last-child)": {
	// 	borderBottom: 0
	// },
	"&:before": {
		height: "0px"
	}
}));

export const CustomAccordionDetails = styled(AccordionDetails)<{
	$backgroundImage: string;
}>`
	&.loyalty-points {
		background-size: 119px;
		background-position: right bottom;
		background-repeat: no-repeat;
		background-image: url(${(props) => props.$backgroundImage});
		padding-bottom: 75px;
		border-radius: 12px;

		@media (orientation: landscape) {
			padding-bottom: 8px;
		}
	}
`;

export const CustomTypography = styled(Typography)`
	&.loyalty-points {
		width: calc(100% - 80px);

		@media (orientation: portrait) {
			width: 100%;
		}
	}
`;

export const Container = styled.div<{ $backgroundImage: string }>`
	position: relative;
	background-image: url(${(props) => props.$backgroundImage});
	background-repeat: no-repeat;
	background-size: 100%;
	width: 100%;
	min-height: 425px;
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-top: 2rem;
	border-radius: 12px;
	overflow: hidden;

	@media (orientation: landscape) {
		background-size: auto;
		background-position: top;
		min-height: 400px;
		//overflow: visible;
	}
`;

export const ItemsContainer = styled.div`
	margin: 10px 0px;
	display: flex;
	flex-direction: column;
	align-items: center;
	width: 95%;
	max-width: 580px;
	@media (orientation: landscape) {
		width: 60%;
		max-width: 580px;
	}
`;

export const BgBrush = styled.img`
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	//height: 100%;
	@media (orientation: landscape) {
		display: none;
	}
`;

export const Character = styled.img`
	display: none;
	position: absolute;
	@media (orientation: landscape) {
		width: 185px;
		display: unset;
	}
`;

export const Title = styled.div`
	color: #113b62;
	z-index: 1;
	margin-top: 55px;
	text-align: center;
	font-family: Baloo;
	font-size: 26px;
	font-style: normal;
	font-weight: 400;
	//line-height: 29px;
`;

export const DotIcon = styled.span`
	font-size: 1rem;
	font-weight: 1000;
	color: #333333;
	line-height: 1.7;

	&::before {
		content: "•";
	}
`;
